/* eslint-disable eqeqeq */
import React from 'react';
import {  Table, Row, Col,Input, Select } from 'antd';
import { withRouter, Link } from "react-router-dom";
import API_URL from '../../constants/API_URL';
const axios = require('axios');

class OrderList extends React.Component {
  constructor(props) { 
    super(props);
    this.state = {
      data: [],
      pagination: {},
      loading: false,
      pageNumber: 0,
      qty: '',
      status: '',
      product: '',
      uom: '',
      lineno:'',
      unitPrice:'',
      totalNetLine:'',
      productsList: [],
      uomsList: [],
      orderId: '',
      showSaleOrderLine: false
    };
    this.lang = this.props.language.INJAZ_POS_ORDERLISTLINE.SETUP;
    
  }


  componentDidMount() {
    this.setState({ orderId: this.props.orderId },
      () => {
        this.fetch();
      }
    )
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");

    var authOptions = {
      method: 'GET',
      url: API_URL + 'productsList',
      params: {
        clientId: localStorage.getItem('clientId'),
        lang: localStorage.getItem('lang')
      },
      headers: {
        'Authorization': tokenType + ' ' + accessToken,
        'Content-Type': 'application/json'
      }
    };
    axios(authOptions)
      .then(result => {
       this.setState({ productsList: result.data })
      })
      .catch(err => {
      })
    let authOptionsWareHouse = { ...authOptions }
    authOptionsWareHouse.url = API_URL + 'warehousesList'
    axios(authOptionsWareHouse)
      .then(result => {
        this.setState({ warehousesList: result.data })
      })
      .catch(err => {
      })
    let authOptionspayMethod = { ...authOptions }
    authOptionspayMethod.url = API_URL + 'uomsList'
    axios(authOptionspayMethod)
      .then(result => {
        this.setState({ uomsList: result.data })
      })
      .catch(err => {
      })

  }
  onChangeSearch = (e) => {
    this.setState({ [e.target.name]: e.target.value }, () => {
      this.fetch()
    })
  }



  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
    this.fetch();
  }




  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
      pageNumber: this.state.pageNumber + 1
    });
    this.fetch({
      results: pagination.pageSize,
      page: pagination.current,
      sortField: sorter.field,
      sortOrder: sorter.order,
      ...filters,
    });
  }

  componentWillReceiveProps(a) {
    if (this.props.orderId != a.orderId) {
      this.setState({ orderId: a.orderId },
        () => {
          this.fetch()
        })
    }
  }


  fetch = (params = {}) => {

    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let clientId = localStorage.getItem("clientId")
    let lang = localStorage.getItem("lang");
    let page;
    let sortOrder = ''
    this.setState({ loading: true });
    if (params.page) {
      page = params.page - 1
    }
    else {
      page = 0;
    }
    if (params.sortOrder && params.sortOrder.toString() === 'ascend') {
      sortOrder = 'ASC'
    }
    else {
      sortOrder = 'DESC'
    }
    let status
    if (params.status) {
      status = params.status
    } else if (this.state.status) {
      status = this.state.status
    }
    let product
    if (params.product) {
      product = params.product
    } else if (this.state.product) {
      product = this.state.product
    }
   
    let uom
    if (params.uom) {
      uom = params.uom
    } else if (this.state.uom) {
      uom = this.state.uom
    }

   
    
    
    let data = {
      lang,
      clientId: clientId,
      order: this.state.orderId,
      sortColumn: params.sortField,
      page,
      status,
      lineno: params.lineno || this.state.lineno || '',
      qty: params.qty || this.state.qty || '',
      unitPrice: params.unitPrice || this.state.unitPrice || '',
      totalNetLine: params.totalNetLine || this.state.totalNetLine || '',
      product,
      uom,
      size: 10,
      sortOrder,
      priority: "",
    }

    axios({
      url: API_URL + 'saleOrderLinesByOrder',
      method: 'POST',
      data,
      headers: {
        'Authorization': tokenType + ' ' + accessToken,
        'Content-Type': 'application/json'
      }
    }).then((data) => {
      const pagination = { ...this.state.pagination };
      pagination.total = data.data.totalElements;

      this.setState({
        loading: false,
        data: data.data.content,
        pagination,
      });
    })
      .catch(err => {
        
      });
  }



  render() {
    const thead = this.lang.TABLEHEADERS
    const searchTitle = this.lang.SEARCHBOXTITLE

    this.columns = [
      {
        title: (
          <span>
            {thead.PRODUCT}  
           <br />
            <Select style={{ width: '100%' }} defaultValue={searchTitle.PRODUCT} onChange={(e) => this.setState({ product: e }, () => { this.fetch() })} >
              {
                this.state.productsList.length > 0 && this.state.productsList.map(item => (
                  <Select.Option value={item.id} key={item.id}>{item.name}</Select.Option>
                ))
              }
            </Select>
          </span>
        ),
        dataIndex: 'product',
        sorter: true,
        render: (text, record) => <button className="link-button" >{
          this.state.productsList.length > 0 && this.state.productsList.filter( item => item.id == text).length > 0 && this.state.productsList.filter( item => item.id == text)[0].name
        }</button>,
      },
      {
        title: (
          <span>
            {thead.QTY}  
              <br /><Input.Search placeholder={searchTitle.QTY}
              type="text" name="qty" onChange={this.onChangeSearch} />
          </span>
        ),
        dataIndex: 'qty',
        sorter: true,
        render: (text, record) => <button className="link-button" >{text}</button>,
      },
      {
        title: (
          <span>
          {thead.UPRICE}
              <br /><Input.Search placeholder={searchTitle.UPRICE}
              type="text" name="unitPrice" onChange={this.onChangeSearch} />
          </span>
        ),
        dataIndex: 'unitPrice',
        sorter: true,
        render: (text, record) => <button className="link-button" >{text}</button>,
      },
      {
        title: (
          <span>
           {thead.TNETPRICE}
              <br /><Input.Search placeholder={searchTitle.TNETPRICE}
              type="text" name="totalNetLine" onChange={this.onChangeSearch} />
          </span>
        ),
        dataIndex: 'totalNetLine',
        sorter: true,
        render: (text, record) => <button className="link-button" >{text}</button>,
      },

      {
        title: (
          <span>
            {thead.UOM}
             <br />
            <Select style={{ width: '100%' }} defaultValue={searchTitle.UOM} onChange={(e) => this.setState({ uom: e }, () => { this.fetch() })} >
              {
                this.state.uomsList.length > 0 && this.state.uomsList.map(item => (
                  <Select.Option value={item.id} key={item.id}>{item.name}</Select.Option>
                ))
              }
            </Select>
          </span>
        ),
        dataIndex: 'uom',
        sorter: true,
        render: (text, record) => <button className="link-button" >{
          this.state.uomsList.length > 0 &&
          this.state.uomsList.filter( item => item.id == text).length > 0 &&
          this.state.uomsList.filter( item => item.id == text)[0].name
        }</button>,
      },
      {
        title: (
          <span>
            {thead.STATUS}
            <br />
            <Select style={{ width: '100%' }} defaultValue={searchTitle.STATUS} onChange={(e) => this.setState({ status: e }, () => { this.fetch() })} >
            {
            this.props.order_status.length > 0 &&  this.props.order_status.map( item => (
              <Select.Option value={item.paramCode} key={item.id}>{item.name}</Select.Option>
            ))
          }
            </Select>
          </span>
        ),
        dataIndex: 'status',
        sorter: true,
        render: (text, record) => <button className="link-button">{
          this.props.order_status.length > 0 &&
          this.props.order_status.filter( item => item.paramCode == text).length > 0 &&
          this.props.order_status.filter( item => item.paramCode == text)[0].name
        }</button>,
      },
    ];
    return (
      <div >
        <div>
          <Row>
            <Col span={12}>
            </Col>
            <Col span={12}><Link to="/dashboard/movementcreate">
             
            </Link>
            </Col>
          </Row>
        </div>
        <Table
          style={{ marginTop: '10px' }}
          columns={this.columns}
          dataSource={this.state.data}
          pagination={this.state.pagination}
          loading={this.state.loading}
          onChange={this.handleTableChange}
          rowKey="id"
          onRow={(record, rowIndex) => {
            return {
              onClick: event => {
                this.setState({ showSaleOrderLine: true, orderId: record.id })
              }

            };
          }}
        />

      </div>
    );
  }
}


export default withRouter(OrderList)
